import * as React from 'react';
import { WarningIcon, CheckMarkIcon } from '../../../webportal/components/common/Icons';

interface ErrorRendererProperties {
    isSuccess?: boolean;
    errorTitle?: string;
    errorMessage: string;
    button?: {
        text: string;
        href: string;
    };
}

export function ErrorRenderer(props: ErrorRendererProperties): JSX.Element {
    const icon: JSX.Element | null = !props.isSuccess ?
        <WarningIcon width="24px" height="20px" /> :
        <CheckMarkIcon width="21px" height="20px" />;

    const cssClass: JSX.Element | string = !props.isSuccess ?
        (
            'msgBox warning'
        ) : (
            'msgBox success'
        );

    return (
        <div className={cssClass} role="alert">
            <div>
                {icon}
                <div>
                    { (props.errorTitle) &&
                    <strong>{props.errorTitle}</strong>
                    }
                    <p>{props.errorMessage}</p>
                </div>
            </div>
            { (props.button) &&
            <a className="btn" href={props.button.href}>{props.button.text}</a>
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/backoffice/components/common/ErrorRenderer.tsx